import { Dexterity, IApiPlayer } from '@trackman/baseball-shared-components';
import { IBoxScoreResponse } from 'interfaces/boxScore/IBoxScoreResponse';

export const emptyGuid = '00000000-0000-0000-0000-000000000000';
export const undefinedValue = 'Undefined';
export const emptyPlayer = {
  id: emptyGuid,
  nameRef: '',
  position: '',
  isPlaceholder: false,
  foreignIds: [],
  battingHandedness: Dexterity.Undefined,
  height: null,
  strikeZoneBottom: null,
  strikeZoneTop: null,
  jerseyNumber: '',
};

export const emptyBoxScore = {
  sessionId: '',
  homeTeam: { teamId: '', teamName: '', pitching: [], batting: [] },
  awayTeam: { teamId: '', teamName: '', pitching: [], batting: [] },
} as IBoxScoreResponse;
